import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import { CommonListParams, DataPagination, Stakeholder } from 'types/common';

type Params = CommonListParams & {
  name?: string;
  role?: string;
  createdBy?: string[];
  status?: string;
  verificationStatus?: boolean;
};

const useStakeholderDataQuery = (params?: Params) => {
  const queryParams = useMemo(
    () => ({
      ...params,
      createdBy: params?.createdBy?.length
        ? params.createdBy.join(',')
        : undefined,
    }),
    [params],
  );
  const query = useQuery<AxiosResponse<DataPagination<Stakeholder>>>({
    queryKey: ['stakeholder-data', queryParams],
    queryFn: () => API.get('/stakeholder/list-data', { params: queryParams }),
  });

  return query;
};

export default useStakeholderDataQuery;
